export function appendPercent(value: number | string, doit = false): string {
  return !doit ? `${value}` : `${value}%`;
}
